<!--suppress ALL -->
<template>
  <g-modal :active.sync="active" class="modal-confirm"
           :width="width"
           :class="btConfirmType ? btConfirmType : ''">
    <div class="box">
      <div class="head">
        <p class="subtitle is-5">{{title}}</p>
      </div>
      <slot></slot>
      <g-field is-grouped position="right">
        <div class="control">
          <g-button @click="$emit('update:active', false)" type="white">{{$t('label.not')}}</g-button>
        </div>
        <div class="control">
          <g-button @click="onConfirm" :isLoading="isLoading"
                    :type="btConfirmType">
            {{confirmLabel}}
          </g-button>
        </div>
      </g-field>
    </div>
  </g-modal>
</template>

<script lang="ts">
  import {Component, Vue, Prop, Watch} from 'annotation';
  import AppConfig from "../../AppConfig";

  @Component
  export default class ModalConfirm extends Vue {

    @Prop({
      default: () => {
        return AppConfig.getVm().$t('label.confirm_delete');
      }, type: String
    })
    public title: string;

    @Prop({default: false, type: Boolean})
    public active: boolean;

    @Prop({default: false, type: Boolean})
    public skipImmediateClose: boolean;

    @Prop({default: false, type: Boolean})
    public isLoading: boolean;

    @Prop({default: 'primary', type: String})
    public btConfirmType: string;

    @Prop({default: 600, type: [String, Number]})
    public width: string | number;

    @Prop({
      default: () => {
        return AppConfig.getVm().$t('label.yes')
      }, type: String
    })
    public confirmLabel: string;

    @Watch('active', {immediate: true})
    public onActiveChange(val: boolean) {
      this.$emit('update:active', val);
    }

    public onConfirm() {
      if (!this.skipImmediateClose) {
        this.$emit('update:active', false);
      }

      this.$emit('confirm');
    }
  }
</script>

<style lang="scss">
  @import "../../style/variables_function";

  .modal-confirm {
    div.head {
      margin: -1.25rem -1.25rem 1rem -1.25rem;
      background-color: $color-primary-young;
      padding: 1.75rem 1.25rem;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;

      p.subtitle {
        color: white !important;
      }
    }

    &.link .head {
      background-color: $link;
    }

    &.primary .head {
      background-color: $color-primary;
    }

    &.primary-young .head {
      background-color: $color-primary-young;
    }

    &.warning .head {
      background-color: $warning;
    }

    &.danger .head {
      background-color: $danger;
    }

    .box .field:last-child .button {
      min-width: 70px;
    }
  }
</style>
